import { render, staticRenderFns } from "./ExplorePlatform.vue?vue&type=template&id=7579d6c4&scoped=true&"
import script from "./ExplorePlatform.vue?vue&type=script&lang=js&"
export * from "./ExplorePlatform.vue?vue&type=script&lang=js&"
import style0 from "./ExplorePlatform.vue?vue&type=style&index=0&id=7579d6c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7579d6c4",
  null
  
)

export default component.exports